export function Footer() {
  return (
    <footer className="flex flex-col items-center gap-3 border-t border-stone-300 bg-cream px-6 py-8 text-center">
      <img src="/logo.jpg" alt="Allthingsnew" className="h-14 w-14 rounded-full object-cover shadow-card" />
      <span className="font-display text-base font-semibold text-ink">Allthingsnew</span>
      <span className="text-xs text-stone-500">Style Her Way — Bags &amp; Designs</span>
      <span className="text-[11px] text-stone-500">&copy; 2026 Allthingsnew. All rights reserved.</span>
    </footer>
  );
}
